<template>
  <div id="OrgRegisterWxBind" title="请关注易比得公众号">
    <!--<el-dialog class="weixin-qrcode-pay" width="860px" :visible.sync="dialogVisible">-->
    <div class="weixin-qrcode-pay" width="860px">
      <div class="pay-content-box">
        <div class="pay-weixin-title">
          <div class="p-w-hd"></div>
          <div class="pay-weixin-title-time">
            <div class="payTimeOne">
              <span> 还差一步，绑定微信 </span>
              <span class="title-right"> REGISTER WECHAT</span>
              <br /><br />
            </div>
            <div class="payTime">请使用微信扫码，根据手机屏幕提示操作。如果您之前没有关注过易比得公众号，请在本屏幕扫码<span>两次</span>。<br /> <br /></div>
            <div class="payTime" >微信扫码后，将<span>自动进入下一步</span>。</div>
          </div>
        </div>
        <div class="pay-weixin-box">
          <div class="pay-weixin-qrCode">
            <WxQrcodeLogin
              :operType="operType"
              title
              :wxData="wxData"
              wxDefaultTip
              wxDefaultTipTwo
              :qrCodeConfig="qrCodeConfig"
            />
            <div class="pay-weixin-qrCode-bottom">
              <p>请使用微信扫一扫</p>
              <p>扫描二维码关注</p>
            </div>
          </div>
          <div class="pay-weixin-box-right"></div>
        </div>
      </div>
    </div>
    <!--</el-dialog> -->
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import WxQrcodeLogin from '@/components/weixin/WxQrcodeLogin';
export default {
  name: 'OrgRegisterWxBind',
  components: {
    WxQrcodeLogin
  },
  props: {
    operType: {
      type: String
    },
    wxData: {}
  },
  data() {
    return {
      // dialogVisible: false,
      qrCodeConfig: {
        width: 150,
        height: 150,
        margin: 0
      }
    };
  },
  created() {
    eventBus.$on('OrgRegisterWxBindVisible', isOpen => {
      this.dialogVisible = isOpen;
    });
  },
  methods: {},
  beforeDestroy() {
    eventBus.$off('OrgRegisterWxBindVisible');
  }
};
</script>
<style scoped lang="less">
.weixin-qrcode-pay {
  // padding-left: 240px;
  .pay-content {
    padding: 0 0 20px 0;
  }
  .pay-content-box {
    background-color: #fff;
    padding: 25px;
    padding-bottom: 160px;
    box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
    font: 12px/150% Arial, Verdana, '宋体';
    -webkit-font-smoothing: auto;
    color: #666;
    .pay-weixin-title {
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      .p-w-hd {
        font-size: 18px;
        font-family: 'Microsoft Yahei';
        padding-right: 18px;
      }
      .pay-weixin-title-time {
        font-family: 'Microsoft Yahei';
        font-size: 18px;
        .payTime {
          color:#6b6b6b;
          font-size: 14px;
          padding-left: 0px;
          padding-top: 5px;
          span {
            color: #fb5b3b;
            font-weight: bold;
          }
        }
        .payTimeOne {
          padding-top: 10px;
        color: #fb5b3b;
        font-size: 24px;
        margin-bottom: 38px;
        .title-right {
        color: #a7a6a6;
        font-size: 14px;
      }
        }
        .expired {
          color: #e31613;
          span {
            color: #67a4ff;
            cursor: pointer;
          }
        }
      }
    }
    .pay-weixin-box {
      padding-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .pay-weixin-qrCode {
        position: relative;
        left:-10px;
        width: 240px;
        // padding-left: 90px;
        .pay-weixin-qrCode-bottom {
          position: relative;
          left:22px;
          height: 44px;
          width:120px;
          padding: 8px 0 8px 70px;
          background: #ff7674 url('../../../assets/img/pc_icon_icon-red.png') 12px 8px no-repeat;
          p {
            margin: 0;
            font-size: 14px;
            line-height: 24px;
            color: #fff;
            font-weight: 700;
          }
        }
      }
    }
    #weixinPayQRCode {
      height: 298px;
      width: 100px;
      border: 1px solid #ddd;
      margin-bottom: 20px;
    }
    .pay-weixin-box-right {
      position: absolute;
      right:20px;
      width: 188px;
      height: 250px;
      //padding-left: 30px;
      margin-top: -13px;
      background: url('../../../assets/img/pc_icon_phone-bg.png') 0px 0 no-repeat;
      background-size: cover;
    }
  }
  .pay-qrcode-fail {
    display: flex;
    justify-content: center;
    .pay-qrcode-fail_error {
      width: 300px;
    }
  }
  .pay-qrcode-confirm {
    display: flex;
    justify-content: center;
  }
}
</style>
